import React from 'react';
import { Info } from 'lucide-react';

export const PlanCards = ({ tiers, currentTier, currentTierRank, onUpgrade, onDowngrade, billingInterval }) => {
  if (!tiers) return null;

  const getPrice = (str) => parseFloat(str.replace('$', ''));

  const tierList = Object.entries(tiers).map(([key, data]) => ({
    key,
    ...data
  })).sort((a, b) => {
    if (typeof a.rank === 'number' && typeof b.rank === 'number') {
      return a.rank - b.rank;
    }
    return getPrice(a.amount_display) - getPrice(b.amount_display);
  });

  const currentTierData = tiers[currentTier];
  const currentRank = currentTierRank ?? currentTierData?.rank;
  const currentPrice = currentTierData ? getPrice(currentTierData.amount_display) : -1;

  return (
    <div className="plan-cards-grid">
      {tierList.map(tier => {
        const isCurrent = currentTier === tier.key;

        const isAnnual = billingInterval === 'year';
        const showAnnualPrice = isAnnual && tier.amount_display_annual;

        const priceDisplay = showAnnualPrice ? tier.amount_display_annual : tier.amount_display;
        const suffix = showAnnualPrice ? '/year' : '/month';

        const tierPrice = getPrice(tier.amount_display);
        let buttonText = 'Upgrade';
        let isDowngrade = false;

        if (isCurrent) {
          buttonText = 'Current plan';
        } else {
          if (typeof tier.rank === 'number' && typeof currentRank === 'number') {
            if (tier.rank < currentRank) {
              buttonText = 'Downgrade';
              isDowngrade = true;
            }
          } else if (currentPrice >= 0 && tierPrice < currentPrice) {
            buttonText = 'Downgrade';
            isDowngrade = true;
          }
        }

        return (
          <div key={tier.key} className={`plan-card ${isCurrent ? 'plan-card--current' : ''}`}>
            <div className="plan-card-header">
              <h3>{tier.label}</h3>
              <div className="plan-price">
                {priceDisplay} <span className="plan-interval">{suffix}</span>
              </div>
              <p className="plan-desc">{tier.description}</p>
            </div>
            <ul className="plan-features">


              {/* Detailed Perks */}
              {tier.perks && tier.perks.map((perk, j) => (
                <li key={j} style={{ alignItems: 'flex-start', display: 'flex' }}>
                  <span style={{ minWidth: '24px' }}></span>
                  <span style={{ flex: 1 }}>{perk.text}</span>
                  {perk.tooltip && (
                    <div className="tooltip-container" style={{ marginLeft: 'auto' }}>
                      <Info size={14} className="tooltip-icon" />
                      <div className="tooltip-content">
                        {perk.tooltip}
                        <div className="tooltip-arrow"></div>
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>
            <button
              className={`plan-btn ${isCurrent ? 'btn-secondary' : 'btn-primary'}`}
              disabled={isCurrent}
              onClick={() => isDowngrade && onDowngrade ? onDowngrade(tier.key) : onUpgrade(tier.key)}
              style={isCurrent ? {
                borderColor: 'rgba(255,255,255,0.2)',
                color: '#fff',
                cursor: 'default'
              } : {
                background: '#fff',
                color: '#000',
                border: '1px solid #fff'
              }}
            >
              {buttonText}
            </button>
          </div>
        );
      })}
    </div>
  );
};

